<script>
import Cookies from 'js-cookie'
import { globalVariablesMixin } from '../../../../Mixins/global'
import mixinComponent from '../../../../Mixins/mixinComponent'
import { platformMixins } from '../../../../Mixins/platform'
import MenuList from './MenuList.vue'
import MenuListItem from './MenuListItem.vue'

export default {
  components: { MenuListItem, MenuList },
  mixins: [globalVariablesMixin, mixinComponent, platformMixins],

  props: {
    menu: {
      type: String,
      required: false,
      default: null,
    },
    expanded: {
      type: Boolean,
      required: false,
      default: true,
    },
    variant: {
      type: String,
      required: false,
      default: 'main',
    },
  },
  computed: {
    savedCollapsedState() {
      const saved = Cookies.get('sidebar_collapsed')
      return saved ? JSON.parse(saved) : false
    },
    classes() {
      const baseClasses = {
        sidebar: true,
        'sidebar-icons-right': true,
        'sidebar-icons-boxed': true,
        'sidebar-collapsed': this.isCollapsed && !this.expanded,
      }

      if (this.variant === 'client') {
        baseClasses['sidebar-lighter'] = true
      }

      return baseClasses
    },
    windowOrigin() {
      return window.location.origin
    },
    getHomePage() {
      return this.isPlatform ? 'home.php' : 'client.php'
    },
  },
  data() {
    const isDesktop = this.isDesktopView()

    return {
      isCollapsed: false,
      isDesktop,
      wasDesktop: isDesktop,
      desktopCollapsedState: false,
    }
  },
  beforeMount() {
    this.isCollapsed = this.isDesktop ? this.savedCollapsedState : true
    this.desktopCollapsedState = Cookies.get('sidebar_collapsed') === 'true'
    this.wasDesktop = this.isDesktop
  },

  mounted() {
    window.addEventListener('resize', this.handleResize)
  },

  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },

  methods: {
    isDesktopView() {
      return window.innerWidth > 768
    },

    toggleSidebar() {
      if (this.isDesktop) {
        this.isCollapsed = !this.isCollapsed
        this.desktopCollapsedState = this.isCollapsed
        Cookies.set('sidebar_collapsed', this.isCollapsed)
      }
    },

    handleResize() {
      const isDesktop = this.isDesktopView()
      this.wasDesktop = isDesktop || this.wasDesktop
      this.isCollapsed = isDesktop ? this.desktopCollapsedState : true
      this.isDesktop = isDesktop

      if (isDesktop && this.expanded) {
        this.$emit('toggle-side-menu', true)
      }
    },
  },
}
</script>
<template>
  <aside :class="classes">
    <header class="sidebar-header my-3">
      <span class="logo">
        <a :href="getHomePage">
          <img
            id="image_logo"
            v-if="conf.theme_dir"
            :src="'/assets/img/' + conf.theme_dir + '.png'"
            :alt="conf.theme_dir"
          />
        </a>
      </span>
    </header>

    <MenuList v-if="isLogged">
      <template v-if="variant === 'client'">
        <li class="menu-category mb-4">{{ $t('wallet.activity') }}</li>

        <MenuListItem
          v-if="isPlatform"
          title-t="menu.home"
          fa-icon="fa-home"
          href="/portefeuille/home.php"
          :class-menu="menu === 'dashboard' ? 'active' : ''"
        />
        <MenuListItem
          v-if="isPlatformClient"
          title-t="menu.myContracts"
          fa-icon="fa-file"
          href="/contrats/client.php"
          :class-menu="menu === 'contracts' ? 'open active' : ''"
        />
        <MenuListItem
          :title-t="isPlatformClient ? 'menu.myPortfolio' : 'menu.myContracts'"
          fa-icon="fa-file"
          href="/portefeuille/client.php"
          :class-menu="menu === 'wallet' ? 'open active' : ''"
        />
      </template>
      <template v-else>
        <MenuListItem
          title-t="menu.home"
          fa-icon="fa-home"
          href="/#/"
          :class-menu="menu == 'dashboard' ? 'active' : ''"
          e2e-button="menuDashboard"
        />

        <MenuListItem
          title-t="menu.mySimulations"
          fa-icon="fa-calculator"
          :href="windowOrigin + '/simulations/index.php?s=0'"
          :class-menu="menu == 'simulations-index' ? 'open active' : ''"
          e2e-button="menuSimulations"
        />

        <MenuListItem
          v-if="hasRole('ROLE_DEMANDS')"
          title-t="menu.myDemands"
          fa-icon="fa-handshake"
          :href="windowOrigin + '/demand/index.php'"
          :class-menu="menu == 'demands-index' ? 'open active' : ''"
          e2e-button="menuDemands"
        />

        <MenuListItem
          title-t="menu.myContracts"
          fa-icon="fa-file-pdf"
          :href="windowOrigin + '/contrats/index.php?s=0'"
          :class-menu="menu == 'contrats-index' ? 'open active' : ''"
          e2e-button="menuContracts"
        />

        <MenuListItem
          title-t="menu.myPortfolio"
          fa-icon="fa-suitcase"
          :href="windowOrigin + '/portefeuille/index.php?s=0'"
          :class-menu="['portefeuille-index', 'restructuring'].includes(menu) ? 'open active' : ''"
          e2e-button="menuPortefeuille"
        />

        <MenuListItem
          v-if="hasRole('ROLE_EQUIPMENT_SHOW')"
          title-t="menu.myEquipments"
          fa-icon="fa-tools"
          :href="windowOrigin + '/equipements/index.php?s=0'"
          :class-menu="menu == 'equipements-index' ? 'open active' : ''"
          e2e-button="menuEquipments"
        />

        <MenuListItem
          v-if="hasRole('ROLE_INVOICE_SHOW')"
          title-t="menu.myInvoice"
          fa-icon="fa-file-alt"
          :href="windowOrigin + '/invoice/index.php?s=0'"
          :class-menu="menu == 'invoices-index' ? 'open active' : ''"
          e2e-button="menuInvoices"
        />

        <MenuListItem
          v-if="hasRole('ROLE_APP_ADMIN_ENTITY_FULL')"
          title-t="menu.society"
          fa-icon="fa-users"
          :href="windowOrigin + '/societes/index.php'"
          :class-menu="menu == 'societes-index' ? 'open active' : ''"
          e2e-button="menuSocietes"
        />

        <MenuListItem
          v-if="user.isBusinessMan && hasRole('ROLE_KPI_SHOW')"
          title-t="menu.kpi"
          fa-icon="fa-chart-bar"
          :href="windowOrigin + '/kpi/index.php'"
          :class-menu="menu == 'kpi-index' ? 'open active' : ''"
          e2e-button="menuKpi"
        />

        <MenuListItem
          v-if="hasRole('ROLE_SUPPORT_FORMULAIRE') && user.supportFormUrl != null"
          title-t="menu.support"
          fa-icon="fa-info"
          :href="user.supportFormUrl"
          target="_blank"
          e2e-button="menuSupport"
        />

        <MenuListItem
          v-if="config.conf.buyout"
          title-t="menu.myBuyout"
          fa-icon="fa-clock"
          :href="windowOrigin + '/buyout/index.php'"
          :class-menu="menu == 'buyout-index' ? 'open active' : ''"
          e2e-button="menuBuyout"
        />

        <MenuListItem
          v-if="false && user.isAdmin"
          title-t="menu.paiement"
          fa-icon="fa-credit-card"
          :href="windowOrigin + '/paiement/index.php'"
          :class-menu="menu == 'paiement-index' ? 'open active' : ''"
          e2e-button="menuPayments"
        />
      </template>
    </MenuList>
  </aside>
</template>
